import { Insurance } from 'Models/UI/Insurance';
import { Payload }   from 'Models/UI/Payload';

export class PayloadInsurance implements Payload {
    insurances : Insurance[]; // TODO array? why?
}